import LangEnum from '../../lang/LangEnum';

interface ResolveFieldEmptyLabelParams {
  isEditable?: boolean;
  placeholder: LangEnum;
}

export const resolveFieldEmptyLabel = ({
  isEditable = true,
  placeholder,
}: ResolveFieldEmptyLabelParams) => (isEditable ? placeholder : LangEnum.GLOBAL_NO_INFORMATIONS);

interface ResolveFieldValueColorParams {
  hasError?: boolean;
  isEmpty?: boolean;
  isEditable?: boolean;
  isMuted?: boolean;
}

export const resolveFieldValueColor = ({
  hasError,
  isEmpty,
  isEditable = true,
  isMuted,
}: ResolveFieldValueColorParams) => {
  if (hasError) {
    return 'error.main';
  }

  if (isEmpty) {
    return isEditable ? 'text.tertiary' : 'text.disabled';
  }

  if (isMuted) {
    return 'text.disabled';
  }

  return 'text.primary';
};
